import { Dropdown } from 'primereact/dropdown'
import React from 'react'

const PagingInfo = ({ paginator, onPerPageChange, totalPage, enablePerPage = true }) => {
    return (
        <div className="" style={{paddingBottom:"25px"}}>
            <div className="d-flex justify-content-end">
                {enablePerPage && <>
                        <div style={{ lineHeight: 2.5, width: 150, textAlign: 'center' }}>
                            Rows per page
                        </div>
                        <div >
                            <select value={paginator.perpage} onChange={onPerPageChange} style={{ width: 70 }} className="form-control">
                                {[5, 10, 25, 50, 100].map((item, i) => (<option key={`option-${i}`} value={item}>{item}</option>))}
                            </select>
                        </div>
                    </>
                }
                <div style={{ lineHeight: 2.5, width: 200, textAlign: 'center' }}>
                    {`Page ${paginator.page} of ${totalPage || 0}`}
                </div>
            </div>
        </div>
    )
}

export default PagingInfo